import React from 'react';
import { useBranding } from '@/lib/branding';

function resolveUrl(url) {
  if (!url) return '/logo-pemkot-makassar.png';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api/')) {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    return `${base}${url}`;
  }
  return url;
}

export function PemkotLogo({ size = 56, withText = false, className = '' }) {
  const branding = useBranding();
  const src = resolveUrl(branding?.logo_url);
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src={src}
        alt="Logo Pemkot Makassar"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: 'contain' }}
        className="flex-shrink-0 drop-shadow"
      />
      {withText && (
        <div className="flex flex-col">
          <span className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">Pemerintah Kota</span>
          <span className="text-base font-bold text-slate-900 leading-tight">Makassar</span>
        </div>
      )}
    </div>
  );
}

export function ProaktifMark({ className = '' }) {
  const branding = useBranding();
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <PemkotLogo size={36} />
      <div className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-semibold">{branding?.institution_name || 'Pemkot Makassar'}</span>
        <span className="text-base font-extrabold text-slate-900" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
          PRO<span className="text-[#DC2626]">AKTIF</span>
        </span>
      </div>
    </div>
  );
}
